import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import type { SetCookieOptions } from './useCookies';

interface Props {
  language: string;
  setCookie: (options: SetCookieOptions) => void;
}

const useSiteLanguage = ({ language, setCookie }: Props) => {
  const { i18n } = useTranslation();

  useEffect(() => {
    if (!language) return;

    if (i18n.language !== language) {
      i18n.changeLanguage(language);
    }

    setCookie({ name: 'language', value: language, days: 30 });
  }, [i18n, language]);
};

export default useSiteLanguage;
